import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
var CleanExclamationSymbolComponent = function (props) { return (React.createElement("span", { className: props.className + " exclamation-symbol" }, "!")); };
export var ExclamationSymbol = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(CleanExclamationSymbolComponent, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-block;\n  margin-left: 5px;\n"], ["\n  color: ", ";\n  display: inline-block;\n  margin-left: 5px;\n"])), function (props) { return props.color || '#ff9800'; });
var templateObject_1;
//# sourceMappingURL=ExclamationSymbol.js.map